import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import Aos from "aos";
import "aos/dist/aos.css";

import {
  Card,
  Row,
  Col,
  Container,
  Carousel,
  CarouselItem,
} from "react-bootstrap";

import resources from "../../assets/resources.svg";
import gallery from "../../assets/gallery.svg";
import trending from "../../assets/trending.svg";
import catalogue from "../../assets/catalogue.svg";

import "../../style/trending.css";
import useFetch from "../hooks/useFetch";


function TrendingandGallery({ icons }) {
  console.log('TrendingIcons')
  console.log(icons)
  useEffect(() => {
    Aos.init({ duration: 2000, delay: 2 });
  }, []);
  return (
    <Container className="overflow-hidden" style={{ overflow: "hidden" }}>
      {/* {icon} */}
      <Card className="text-center border-0 my-5 p-0 m-1">
        <Card.Body className="p-0">
          <Row xs={1} sm={2} md={2} className="g-4 ">
            <Col
              xs={12}
              sm={12}
              md={5}
              className="text-start trending-content text-dark card-border"
            >
              <Card.Title
                className="text-maroon h2"
                style={{ textTransform: "capitalize" }}
              >
                Paulines books and audiovisuals Africa
              </Card.Title>

              <Card.Text>
                The mission of the Daughters of St Paul is to be at the service of
                evangelisation through the means of social communications: “To do
                the charity of the truth” according to Blessed James Alberione,
                their founder. Paulines' strategies and priorities are set according
                to the needs of the people and following the directives of the
                Congregation and the Church, particularly the African Church.
              </Card.Text>
              <Card.Text>
                Paulines Africa publishes and produces books and audiovisual
                materials based on bible, catechesis, the teaching of the Church,
                formation to justice and peace, life education and literature for
                children.
              </Card.Text>
            </Col>
            <Col sm={12} md={7}>
              {/* Large screens */}
              <Row xs={12} sm={6} md={12} className="g-3 d-none d-md-flex p-0">
                {icons && icons.map((url, idx) => (
                  <Col xs={12} sm={6} md={6} key={idx}>
                    <NavLink to={url.link} className="text-dark d-block">
                      <Card
                        className="shadow-on-hover rounded-3"
                        data-aos={url.animation}
                      >
                        <Card.Body>
                          <Card.Img
                            variant="top"
                            src={url.icon}
                            className="rounded-3"
                          />
                        </Card.Body>
                      </Card>
                    </NavLink>
                  </Col>
                ))}
              </Row>

              {/* Small screens */}
              <div className="d-md-none">
                <Carousel indicators={false} controls={true}>
                  {icons && icons.map((url, idx) => (
                    <CarouselItem key={idx}>
                      <NavLink to={url.link} className="text-dark d-block">
                        <Card
                          className="shadow-on-hover rounded-3"
                          data-aos={url.animation}
                        >
                          <Card.Body>
                            <Card.Img
                              variant="top"
                              src={url.icon}
                              className="rounded-3"
                            />
                          </Card.Body>
                        </Card>
                      </NavLink>
                    </CarouselItem>
                  ))}
                </Carousel>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
}
export default TrendingandGallery;
